import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router';

import { authOperations } from './../../../reducks/auth';
import { commonOperations } from './../../../reducks/common';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const styles = theme => ({
  root: {
    display: 'flex',
  },
  dialogContext: {
    color: 'black',
    whiteSpace: "pre-line",
  }
});

class CustomDialog extends React.Component {

  handleErr = event => {
    this.props.doCloseDialog();
    // this.props.doLogout();
  }

  handleClose = (event, reason) => {

    console.log('reason', reason);
    if (reason === 'backdropClick') return;
    
    if (this.props.dialogInfo.notFormat) {
      this.props.doCloseDialogNotFormat();

    } else {
      this.props.doCloseDialog();
    }
  }

  handleOk = event => {
    this.props.doCloseDialog();
    this.props.dialogInfo.action();
  }

  render() {
    const { dialogInfo, classes } = this.props;

    return (
      <div>
        <Dialog
          open={dialogInfo.open}
          onClose={this.handleClose}
          // disableBackdropClick={true}
          aria-labelledby="responsive-dialog-title"
        >
          {dialogInfo.title &&
            <DialogTitle id="responsive-dialog-title">
              <FormattedMessage id={dialogInfo.title}/>
            </DialogTitle>
          }
          {dialogInfo.context &&
            <DialogContent>
              <DialogContentText className={classes.dialogContext}>
              {dialogInfo.notFormat
                ? <span>{dialogInfo.context}</span>
                : <FormattedMessage id={dialogInfo.context}/>
              }
              </DialogContentText>
            </DialogContent>
          }
          {(dialogInfo.type === 'ok') &&
            <DialogActions>
              <Button onClick={this.handleOk} id="btnOk" color="primary">
                <FormattedMessage id={'Dialog.btn.ok'}/>
              </Button>
            </DialogActions>
          }
          {(dialogInfo.type === 'okcancel') &&
            <DialogActions>
              <Button onClick={this.handleOk} id="btnOk" color="primary">
                <FormattedMessage id={'Dialog.btn.ok'}/>
              </Button>
              <Button onClick={this.handleClose} id="btnCancel" color="primary">
                <FormattedMessage id={'Dialog.btn.cancel'}/>
              </Button>
            </DialogActions>
          }
          {(dialogInfo.type === 'close') &&
          <DialogActions>
            <Button onClick={this.handleClose} id="btnClose" color="primary">
              <FormattedMessage id={'Dialog.btn.close'}/>
            </Button>
          </DialogActions>
          }
          {(dialogInfo.type === 'error') &&
            <DialogActions>
              <Button onClick={this.handleErr} id="btnClose" color="primary">
                <FormattedMessage id={'Dialog.btn.close'}/>
              </Button>
            </DialogActions>
          }
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  dialogInfo: state.common.dialogInfo,
});

const mapDispatchToProps = {
  doCloseDialog: commonOperations.closeDialogOperation,
  doCloseDialogNotFormat: commonOperations.closeDialogNotFormatOperation,
  doLogout: authOperations.logoutOperation,
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(CustomDialog))
);
